import { useEffect } from "react";

export const useEditorRuntimeSync = ({
  changeInEditor,
  setUpdatedValue,
  selectedComponent,
  playPause,
  playPauseRef,
  myStateRef,
  setCheckedAspect,
}) => {
  useEffect(() => {
    setUpdatedValue((prevState) => ({
      ...prevState,
      componentStyles: selectedComponent?.componentStyles,
    }));
  }, [changeInEditor]);

  useEffect(() => {
    playPauseRef.current = playPause;
  }, [playPause]);

  const ToggleAspectLock = (event) => {
    myStateRef.current = event.target.checked;
    setCheckedAspect(event.target.checked);
  };

  return { ToggleAspectLock };
};
